import { Alert } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Device, DeviceSupported } from '../../api/api-types';

const translationKeyByStatus: Record<Exclude<DeviceSupported, 'Supported'>, string> = {
  UnsupportedGenesisVersion: 'portal.keys.device-unsupported-component.unsupportedGenesisVersion',
  UnsupportedThermiaConnectVersion: 'portal.keys.device-unsupported-component.unsupportedThermiaConnectVersion',
  UnsupportedConnectionType: 'portal.keys.device-unsupported-component.unsupportedConnectionType',
  UnknownConnectionType: 'portal.keys.device-unsupported-component.unknownConnectionType'
};

const DeviceUnsupportedComponent: FC<{ device: Device }> = ({ device }) => {
  const { t } = useTranslation('portal');

  if (device.deviceSupported === 'Supported') return null;

  const translationKey = translationKeyByStatus[device.deviceSupported];

  return (
    <Alert severity="warning" variant="filled">
      {t(translationKey)}
    </Alert>
  );
};

export default DeviceUnsupportedComponent;
